import { Helmet } from "react-helmet-async";
import { m } from 'framer-motion';
// @mui
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// components
import { MotionContainer, varBounce } from '../components/animate';
// assets
import { PageNotFoundIllustration } from '../assets/illustrations';
import { useRouter } from "../routes/hooks";

const NotFoundPage = () => {

    const router = useRouter();

    return (
        <>
            <Helmet>
                <title>404 Page Not Found!</title>
            </Helmet>
            <MotionContainer>
                <m.div variants={varBounce().in}>
                    <Typography variant="h3" sx={{ mb: 2 }}>
                        Desculpe, Página não encontrada!
                    </Typography>
                </m.div>

                <m.div variants={varBounce().in}>
                    <Typography sx={{ color: 'text.secondary' }}>
                    Desculpe, mas não conseguimos encontrar a página que procura. Talvez você tenha digitado incorretamente a URL? Certifique-se de verificar sua ortografia.
                    </Typography>
                </m.div>

                <m.div variants={varBounce().in}>
                    <PageNotFoundIllustration
                        sx={{
                            height: 260,
                            my: { xs: 5, sm: 10 },
                        }}
                    />
                </m.div>

                <Button onClick={() => router.back()} size="large" variant="contained">
                    Voltar Para à Página Anterior
                </Button>
            </MotionContainer>
        </>
    );

}

export default NotFoundPage;